var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function showPricebox() {
    if($('[name="sub-save-radio"]:checked').val() == "subscribe") {
      $('.offer_box_sub_save').show();
	  $('.offer_box_one_time').hide();
	}
    else {
       $('.offer_box_sub_save').hide();
	  $('.offer_box_one_time').show();
       
    }

}

function isOnScreen(s) {
    if (s.length != 0) {
        var e = jQuery(window),
            t = e.scrollTop(),
            o = e.height(),
            l = t + o,
            n = jQuery(s),
            i = n.offset().top,
            r = n.height(),
            a = i + r;
        return (i >= t && i < l) || (a > t && a <= l) || (r > o && i <= t && a >= l);
    }
  }
  
  
  $(document).ready(function() {
    isOnScreen($(".non-sticky-atc-button").eq(0)) ||
    isOnScreen($(".non-sticky-atc-button").eq(1)) ||
    isOnScreen($(".non-sticky-atc-button").eq(2)) ||
    isOnScreen($(".non-sticky-atc-button").eq(3)) ||
    isOnScreen($(".non-sticky-atc-button").eq(4)) ||
    isOnScreen($(".non-sticky-atc-button").eq(5)) ||
    isOnScreen($(".non-sticky-atc-button").eq(6)) ||
    isOnScreen($(".non-sticky-atc-button").eq(7)) ||
    isOnScreen($(".non-sticky-atc-button").eq(8)) ||
    isOnScreen($("#footer"))
        ? $(".sticky-atc-button").fadeOut(100)
        : $(".sticky-atc-button").fadeIn(0), //was 100
        $(window).on("scroll", function () {
            isOnScreen($(".non-sticky-atc-button").eq(0)) ||
            isOnScreen($(".non-sticky-atc-button").eq(1)) ||
            isOnScreen($(".non-sticky-atc-button").eq(2)) ||
            isOnScreen($(".non-sticky-atc-button").eq(3)) ||
            isOnScreen($(".non-sticky-atc-button").eq(4)) ||
            isOnScreen($(".non-sticky-atc-button").eq(5)) ||
            isOnScreen($(".non-sticky-atc-button").eq(6)) ||
            isOnScreen($(".non-sticky-atc-button").eq(7)) ||
            isOnScreen($(".non-sticky-atc-button").eq(8)) ||
            isOnScreen($("#footer"))
                ? $(".sticky-atc-button").fadeOut(10)
                : $(".sticky-atc-button").fadeIn(10);
        }),
    // Toggle menu js start here 
    $('.js-menu-toggle').on('click',function(){
        $('.menu').addClass('open');
        $('body').addClass('menu-open');
    });
    $('.js-menu-close').on('click',function(){
        $('.menu').removeClass('open');
        $('body').removeClass('menu-open');
    });
    $('.menu ul>li>a').on('click',function(){
        $('.menu').removeClass('open');
        $('body').removeClass('menu-open');
    });
  
    $(document).mouseup(function(e) 
    {
        if (!$('.menu').is(e.target) && $('.menu').has(e.target).length === 0) 
        {
            $('.menu').removeClass('open');
            $('body').removeClass('menu-open');
        }
    });
  
    // Toggle menu js end here 
  
  
  // Product Slider
  
  $('.product-slider').slick({
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      dots:true,
      prevArrow:"<button type='button' class='slick-prev icon-angle-left'></button>",
      nextArrow:"<button type='button' class='slick-next icon-angle-right'></button>",
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '250px',
            arrows:false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '190px',
            arrows:false
          }
        },
        {
          breakpoint: 641,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '160px',
            arrows:false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '85px',
            arrows:false
          }
        }
      ]
    });
  
  
  // Qty add remove
  
  	
     $(document).on('click','.add',function(e){
      var th = $(this).closest('.qty-wrap').find('.count');    	
      th.val(+th.val() + 1);
    });
    
           $(document).on('click','.sub',function(e){

      var th = $(this).closest('.qty-wrap').find('.count');    	
            if (th.val() > 0) th.val(+th.val() - 1);
    });
  
  
  // Product Slider
  
  $('.coffee-process-slider').slick({
    lazyLoad: 'ondemand',
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows:false,
    dots:false,
    infinite: false,
    prevArrow:"<button type='button' class='slick-prev icon-angle-left'></button>",
    nextArrow:"<button type='button' class='slick-next icon-angle-right'></button>",
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1,
          arrows:false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 1,
          arrows:true
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
          arrows:true
        }
      }
    ]
  });
  
  
  // Do you know Slider
  
  $('.know-slider').slick({
    lazyLoad: 'ondemand',
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows:true,
    dots:true,
    prevArrow:"<button type='button' class='slick-prev icon-angle-left'></button>",
    nextArrow:"<button type='button' class='slick-next icon-angle-right'></button>",
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '100px',
          arrows:false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '150px',
          arrows:false
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '50px',
          arrows:false
        }
      }
    ]
  });
  
  
  // FAQ Accordian
  
//   $('.accordion .toggle').click(function(e) {
//     e.preventDefault();
  
//   let $this = $(this);
  
//   if ($this.next().hasClass('show')) {
//       $this.next().removeClass('show');
//       $this.next().slideUp(350);
//   } else {
//       $this.parent().parent().find('li .inner').removeClass('show');
//       $this.parent().parent().find('li .inner').slideUp(350);
//       $this.next().toggleClass('show');
//       $this.next().slideToggle(350);
//   }
//   });
//   $('.accordion li a').on('click', function(){
//     $(this).parent().siblings().removeClass('active');
//     $(this).parent().toggleClass('active');
//   });
  
  
  // Nutrition Slider
  
  $('.nutrition-slider').slick({
    lazyLoad: 'ondemand',
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows:true,
    dots:true,
    infinite: false,
    prevArrow:"<button type='button' class='slick-prev icon-angle-left'></button>",
    nextArrow:"<button type='button' class='slick-next icon-angle-right'></button>",
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.15,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1.15,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  
    /* scroll to target */
    jQuery('.scrollTo').click(function(e) {
        var jump = jQuery(this).attr('href');
        var new_position = jQuery(jump).offset();
        var scroll = 0;
        jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800, function(){
            var new_position = jQuery(jump).offset();
            jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800);
          
        });
        e.preventDefault();
    });
  
  
  });



// FAQ Accordian


var accordion = (function () {
  var $accordion = $(".js-accordion");
  var $accordion_header = $accordion.find(".js-accordion-header");
  var $accordion_item = $(".js-accordion-item");

  // default settings
  var settings = {
    // animation speed
    speed: 400,

    // close all other accordion items if true
    oneOpen: false
  };

  return {
    // pass configurable object literal
    init: function ($settings) {
      $accordion_header.on("click", function () {
        accordion.toggle($(this));
      });

      $.extend(settings, $settings);

      // ensure only one accordion is active if oneOpen is true
      if (settings.oneOpen && $(".js-accordion-item.active").length > 1) {
        $(".js-accordion-item.active:not(:first)").removeClass("active");
      }

      // reveal the active accordion bodies
      $(".js-accordion-item.active").find("> .js-accordion-body").show();
    },
    toggle: function ($this) {
      if (
        settings.oneOpen &&
        $this[0] !=
          $this
            .closest(".js-accordion")
            .find("> .js-accordion-item.active > .js-accordion-header")[0]
      ) {
        $this
          .closest(".js-accordion")
          .find("> .js-accordion-item")
          .removeClass("active")
          .find(".js-accordion-body")
          .slideUp();
        // Added by Aman
        $this.closest(".faq-row").find(".js-accordion-item").removeClass("active").find(".js-accordion-body").slideUp();
      }
      


      // show/hide the clicked accordion item
      $this.closest(".js-accordion-item").toggleClass("active");
      
      $this.next().stop().slideToggle(settings.speed);
     
    }
  };
})();

$(document).ready(function () {
  accordion.init({ speed: 300, oneOpen: true });
});


$(document).ready(function() {
   $.get("/cart/clear",function(){
  $(document).on('click','.sales_page_atc',function(e){
    e.preventDefault();
	let totalqty = 0;
   
    let itemsArray = [];
    $('[name="variant[]"]').each(function(em, ix) {
      let currentElement = $(this);
      let vid = $(currentElement).attr('data-variant-id');
      let qty = $(currentElement).val();
      totalqty += parseInt(qty);
      
	 
      let selling_plan_allocation = $(currentElement).attr('data-selling-plan-id'); 
      if($('[name="sub-save-radio"]:checked').val() == "otp") {
      let singleItem = {id: vid, quantity: qty};
      itemsArray.push(singleItem);
      } else {
        let singleItem = {id: vid, quantity: qty, selling_plan : selling_plan_allocation};
      itemsArray.push(singleItem);
         
      }
      
    });
    
    let discount = '';
    if($('[name="sub-save-radio"]:checked').val() == "otp") {
      //Buy 2 get 1 free - buy 6 get 2 free adjustment - 16/02
  
      if(totalqty < 3){ //qty 1 or 2
        //in actual use discount = 0 - kept to disc.1 for possible future special use case.
        discount = window.moin_discount1;
      } 
      else if(totalqty < 6){ //qty 3, 4 and 5.
        discount = window.moin_discount2; //19,99
      }
      else if(totalqty >= 6){
        discount = window.moin_discount3; //39,98
      }
    }
      else {
        //same for sub plans, IF they are configured...
              if(totalqty < 3){

        discount = window.moin_sub_discount1;
      } 
      else if(totalqty < 6){ //qty 3, 4 and 5.
        discount = window.moin_sub_discount2; 
      }
      else if(totalqty >= 6){
        discount = window.moin_sub_discount3;
      }

//window.moin_subdiscount4 is unused.


      }
     
     
    if($(".premium-check-box input[type='checkbox']").prop("checked") == true)
    {
      let upsell_pro_id = $('#premium-checkbox').val();
      let singleUpsellItem = {id: upsell_pro_id, quantity: 1 };
      itemsArray.push(singleUpsellItem);
    }
    if(totalqty > 0)
    {
    $.ajax({
      "url"       :   "/cart/add.js",
      "method"    :   "POST",
      "dataType"  :   "JSON",
      data       :   {items: itemsArray},
      "success"   :   function(data) {
        console.log('data added');
        window.location = '/checkout?discount=' + discount;
      },
      "error"     :   function(data) {
        window.alert(data.responseJSON.description);
      }
    }); 
    } 

 }); 
   
});


//code adj. Mike 08/02 - making totalPrice, totalQuantity and otpDisprice global for plugin access.

  function bottle_saving(){
  $(document).on('click','.add,.sub',function(e){
        let totalPrice = 0;
        let totalQuantity = 0;
    let totalSubprice = 0;
    let totalSavingprice = 0;
        let discountper = 0;;
        let otpDisprice = 0;
    let image = '';
//     console.log(image)
   
    $(`[name="variant[]"]`).each(function(ix,em){
      //console.log(parseInt($(em).val()));
      //console.log($(em).attr(`data-otp-price`))
      image = $(em).attr(`data-image`);
      totalQuantity += parseInt($(em).val());
      totalPrice += parseInt($(em).val()) * parseInt($(em).attr(`data-otp-price`));

      
      //otpDisprice += parseInt($(em).val()) * parseInt($(em).attr(`data-otp-dis-price`));

      totalSubprice +=  parseInt($(em).val()) * parseInt($(em).attr(`data-bottle-sub-price`)); 
if($('[name="sub-save-radio"]:checked').val() == "otp") {
      if(totalQuantity < 3){
        otpDisprice = 1999 * totalQuantity; //NO effective savings - do not show crossed out price here.
      }else if(totalQuantity < 6){
        otpDisprice = 1999  * (totalQuantity-1); //1 free.
      }else if(totalQuantity >= 6){
        otpDisprice = 1999  * (totalQuantity-2); //2 free.
      }
      totalSavingprice = 100 * (totalPrice - otpDisprice);
      if(totalQuantity > 0){
        discountper =  totalSavingprice / totalPrice;
      }

} else {
  //implementation only relevant for SUBS! preparation here.
    if(totalQuantity < 3){
        otpDisprice = 1699 * totalQuantity; //NO effective savings - do not show crossed out price here.
      }else if(totalQuantity < 6){
        otpDisprice = 1699  * (totalQuantity-1); //1 free.
      }else if(totalQuantity >= 6){
        otpDisprice = 1699  * (totalQuantity-2); //2 free.
      }
      totalSavingprice = 100 * (totalPrice - otpDisprice);
      if(totalQuantity > 0){
        discountper =  totalSavingprice / totalPrice;
      }
  
}
    });

 //  console.log(discountper);
 //   console.log("(CW)Compare at: "+ totalPrice)
 //   console.log("(CW)Total incl. Discs: " + otpDisprice);
   
   //mike's function trigger - 08/02 
    window.plugintotalPrice = totalPrice;
    window.plugintotalqty = totalQuantity;
    window.pluginotpdisprice = otpDisprice;
   mikeplugin();
    
   
//console.log(Shopify.formatMoney(discountper, $('body').attr('data-money-format')));

    var index= $(this).attr('data-id');
    $('.product-slider').each(function(){
	  var slick_image = $(this).find('img').attr('src');
      $('.product-slider').slick('slickGoTo',parseInt(index)-1);
	});



    //17/02 -- JAVY PRICE FUNCTION enabled, but at different place. --> bottle_qty_price-mike, was bottle_qty_price
    
    if($('[name="sub-save-radio"]:checked').val() == "subscribe") {
      let perbottle = otpDisprice / totalQuantity;
      let perbottle_EUR = Shopify.formatMoney(perbottle, $('body').attr('data-money-format'));
      
    if(totalQuantity < 3){
     $('.bottle_qty_price-mike').text("");
     $('.perbottle-price-mike').text("");
     $(".mike-savings").hide();
      
      }else if(totalQuantity >= 3){
      $(".mike-savings").show();
      $('.bottle_qty_price-mike').text("Du sparst " + Math.round(discountper) + "%");
      $('.perbottle-price-mike').text("Nur " + perbottle_EUR + " pro Flasche");
      }

      
      /*
      if(totalQuantity == 1){
        //$('.bottle_qty_price').text(`Buy more, pay less: 1 bottle - You're saving ` + Math.round(discountper) + `%`);
        $('.js_bottle_count').text(`1`);
        $('.js_bottle_per').text(Math.round(discountper) + `%`);
        
      }else if(totalQuantity == 2){
        $('.bottle_qty_price').html(`Buy more, pay less: 2 bottles - You're saving ` + Math.round(discountper) + `%`);
        $('.js_bottle_count').text(`2`);
        $('.js_bottle_per').text(Math.round(discountper) + `%`);
        
      }else if(totalQuantity == 3){
        $('.bottle_qty_price').html(`Buy more, pay less: 3 bottles - You're saving ` + Math.round(discountper) + `%`);
        $('.js_bottle_count').text(`3`);
        $('.js_bottle_per').text(Math.round(discountper) + `%`);
        
      }else if(totalQuantity >= 4){
        //$('.bottle_qty_price').text(`Buy more, pay less: 4 bottles - You're saving ` + Math.round(discountper) + `%`);
        $('.js_bottle_count').text(`4`);
        $('.js_bottle_per').text(Math.round(discountper) + `%`);
        
      }
      */

    }
    else {

      let perbottle = otpDisprice / totalQuantity;
      let perbottle_EUR = Shopify.formatMoney(perbottle, $('body').attr('data-money-format'));
      
    if(totalQuantity < 3){
     $('.bottle_qty_price-mike').text("");
     $('.perbottle-price-mike').text("");
      
      }else if(totalQuantity >= 3){
      $('.bottle_qty_price-mike').text("Du sparst " + Math.round(discountper) + "%");
      $('.perbottle-price-mike').text("Nur " + perbottle_EUR + " pro Flasche");
      }

      
      
/*
      if(totalQuantity == 1){
        //$('.bottle_qty_price').text(`Buy more, pay less: 1 bottle - You're saving ` + Math.round(discountper) + `%`);
         $('.js_bottle_count').text(`1`);
        $('.js_bottle_per').text(Math.round(discountper) + `%`);
      }else if(totalQuantity == 2){
        //$('.bottle_qty_price').html(`Buy more, pay less: 2 bottles - You're saving ` + Math.round(discountper) + `%`);
         $('.js_bottle_count').text(`2`);
        $('.js_bottle_per').text(Math.round(discountper) + `%`);
      }else if(totalQuantity == 3){
        //$('.bottle_qty_price').html(`Buy more, pay less: 3 bottles - You're saving ` + Math.round(discountper) + `%`);
         $('.js_bottle_count').text(`3`);
        $('.js_bottle_per').text(Math.round(discountper) + `%`);
      }else if(totalQuantity >= 4){
        //$('.bottle_qty_price').text(`Buy more, pay less: 4 bottles - You're saving ` + Math.round(discountper) + `%`);
         $('.js_bottle_count').text(`4`);
        $('.js_bottle_per').text(Math.round(discountper) + `%`);
      }
*/
    }
    
});


  }  

// Add class in diff browser  

    if (navigator.userAgent.indexOf('Mac') > 0)
        $('body').addClass('mac-os');
    if (navigator.userAgent.indexOf('Safari') > 0)
        $('body').addClass('safari');
    if (navigator.userAgent.indexOf('Chrome') > 0)
        $('body').addClass('chrome');
  
  
  $(document).on('change','[name="sub-save-radio"]',function(e){
   showPricebox();
    console.log('radio button changed');
 
    
    let totalPrice = 0;
    let totalQuantity = 0;
    let totalSubprice = 0;
    let totalSavingprice = 0;
    let discountper = 0;
    let otpDisprice = 0;

   
//     console.log(image)
   
    $(`[name="variant[]"]`).each(function(ix,em){
      //console.log(parseInt($(em).val()));
      //console.log($(em).attr(`data-otp-price`))
      image = $(em).attr(`data-image`);
      totalQuantity += parseInt($(em).val());
      totalPrice += parseInt($(em).val()) * parseInt($(em).attr(`data-otp-price`));
      //otpDisprice += parseInt($(em).val()) * parseInt($(em).attr(`data-otp-dis-price`));

      totalSubprice +=  parseInt($(em).val()) * parseInt($(em).attr(`data-bottle-sub-price`)); 
if($('[name="sub-save-radio"]:checked').val() == "otp") {
   
      if(totalQuantity < 3){
        otpDisprice = 1999 * totalQuantity; //NO effective savings - do not show crossed out price here.
      }else if(totalQuantity < 6){
        otpDisprice = 1999  * (totalQuantity-1); //1 free.
      }else if(totalQuantity >= 6){
        otpDisprice = 1999  * (totalQuantity-2); //2 free.
      }
      totalSavingprice = 100 * (totalPrice - otpDisprice);
      if(totalQuantity > 0){
        discountper =  totalSavingprice / totalPrice;
      }

} else {
   //PREPARED FOR BOLD SUBS
    if(totalQuantity < 3){
        otpDisprice = 1699 * totalQuantity; //NO effective savings - do not show crossed out price here.
      }else if(totalQuantity < 6){
        otpDisprice = 1699  * (totalQuantity-1); //1 free.
      }else if(totalQuantity >= 6){
        otpDisprice = 1699  * (totalQuantity-2); //2 free.
      }
      totalSavingprice = 100 * (totalPrice - otpDisprice);
      if(totalQuantity > 0){
        discountper =  totalSavingprice / totalPrice;
      }

}

        //mike's function trigger - 08/02 
    plugintotalPrice = totalPrice;
    plugintotalqty = totalQuantity;
    pluginotpdisprice = otpDisprice;
   mikeplugin();
      
    });
//console.log(Shopify.formatMoney(discountper, $('body').attr('data-money-format')));

     

  if($('[name="sub-save-radio"]:checked').val() == "subscribe") {
      let perbottle = otpDisprice / totalQuantity;
      let perbottle_EUR = Shopify.formatMoney(perbottle, $('body').attr('data-money-format'));
      
    if(totalQuantity < 3){
     $('.bottle_qty_price-mike').text("");
     $('.perbottle-price-mike').text("");
     $(".mike-savings").hide();
      
      }else if(totalQuantity >= 3){
      $(".mike-savings").show();
      $('.bottle_qty_price-mike').text("Du sparst " + Math.round(discountper) + "%");
      $('.perbottle-price-mike').text("Nur " + perbottle_EUR + " pro Flasche");
      }

    /*
      if(totalQuantity == 1){
        //$('.bottle_qty_price').text(`Buy more, pay less: 1 bottle - You're saving ` + Math.round(discountper) + `%`);
        $('.js_bottle_count').text(`1`);
        $('.js_bottle_per').text(Math.round(discountper) + `%`);
          
        
      }else if(totalQuantity == 2){
        //$('.bottle_qty_price').html(`Buy more, pay less: 2 bottles - You're saving ` + Math.round(discountper) + `%`);
        $('.js_bottle_count').text(`2`);
        $('.js_bottle_per').text(Math.round(discountper) + `%`);
        
      }else if(totalQuantity == 3){
        //$('.bottle_qty_price').html(`Buy more, pay less: 3 bottles - You're saving ` + Math.round(discountper) + `%`);
        $('.js_bottle_count').text(`3`);
        $('.js_bottle_per').text(Math.round(discountper) + `%`);
        
      }else if(totalQuantity >= 4){
        //$('.bottle_qty_price').text(`Buy more, pay less: 4 bottles - You're saving ` + Math.round(discountper) + `%`);
        $('.js_bottle_count').text(`4`);
        $('.js_bottle_per').text(Math.round(discountper) + `%`);
        
      }

    */

    }
    else {

      let perbottle = otpDisprice / totalQuantity;
      let perbottle_EUR = Shopify.formatMoney(perbottle, $('body').attr('data-money-format'));
      
    if(totalQuantity < 3){
     $('.bottle_qty_price-mike').text("");
     $('.perbottle-price-mike').text("");
      
      }else if(totalQuantity >= 3){
      $('.bottle_qty_price-mike').text("Du sparst " + Math.round(discountper) + "%");
      $('.perbottle-price-mike').text("Nur " + perbottle_EUR + " pro Flasche");
      }
      /*
      if(totalQuantity == 1){
        //$('.bottle_qty_price').text(`Buy more, pay less: 1 bottle - You're saving ` + Math.round(discountper) + `%`);
         $('.js_bottle_count').text(`1`);
        $('.js_bottle_per').text(Math.round(discountper) + `%`);
      }else if(totalQuantity == 2){
        //$('.bottle_qty_price').html(`Buy more, pay less: 2 bottles - You're saving ` + Math.round(discountper) + `%`);
         $('.js_bottle_count').text(`2`);
        $('.js_bottle_per').text(Math.round(discountper) + `%`);
      }else if(totalQuantity == 3){
        //$('.bottle_qty_price').html(`Buy more, pay less: 3 bottles - You're saving ` + Math.round(discountper) + `%`);
         $('.js_bottle_count').text(`3`);
        $('.js_bottle_per').text(Math.round(discountper) + `%`);
      }else if(totalQuantity >= 4){
        //$('.bottle_qty_price').text(`Buy more, pay less: 4 bottles - You're saving ` + Math.round(discountper) + `%`);
         $('.js_bottle_count').text(`4`);
        $('.js_bottle_per').text(Math.round(discountper) + `%`);
      }
      */
      
    }
   
   
  });
          
   
bottle_saving();

  
 });

$(document).ready(function() {
 
  showPricebox();
});



// $(document).ready(function(){
//   $('#add').trigger('click');
// });
